import PropTypes from 'prop-types';
import React from 'react';
import SaveIndicator from 'contest/components/save-indicator';

const RawHtml = ({ html }) => <span dangerouslySetInnerHTML={{ __html: html }} />;
RawHtml.propTypes = {
    html: PropTypes.string.isRequired,
};

const EditElementFrame = props => {
    const { message, messagePosition } = props;
    return (
        <div className="field field--with-save-indicator">
            <div className="field__save-indicator">
                <SaveIndicator state={props.saveState} onRetry={props.onRetry} />
            </div>
            <div className="field__title">{props.title}</div>
            {message &&
                messagePosition == 'top' && (
                    <p>
                        <RawHtml html={message} />
                    </p>
                )}
            <div className="field__input">{props.children}</div>
            {message &&
                messagePosition != 'top' && (
                    <div className="field__message">
                        <RawHtml html={message} />
                    </div>
                )}
        </div>
    );
};
EditElementFrame.propTypes = {
    title: PropTypes.node.isRequired,
    message: PropTypes.string,
    saveState: PropTypes.oneOf(['saving', 'saved', 'error']),
    children: PropTypes.node.isRequired,
    onRetry: PropTypes.func,
    messagePosition: PropTypes.string,
};
EditElementFrame.defaultProps = {
    onRetry: () => {},
};
export default EditElementFrame;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/edit-element-frame.jsx